module.exports = __webpack_public_path__ + "media/images/photo16-34da8a5a89964d184a945f3f1f3c8653.png";